var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form-group", class: { "has-error": _vm.model.$error } },
    [
      _vm.labelPosition === "left"
        ? _c(
            "label",
            { staticClass: "control-label col-sm-4" },
            [
              _vm._t("default", function () {
                return [
                  _vm._v(
                    _vm._s(_vm.required ? "*" : "") +
                      " " +
                      _vm._s(_vm.fieldName)
                  ),
                ]
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { class: _vm.labelPosition === "left" ? "col-sm-8" : "" }, [
        _vm.labelPosition === "top"
          ? _c(
              "label",
              { staticClass: "control-label" },
              [
                _vm._t("default", function () {
                  return [
                    _vm._v(
                      _vm._s(_vm.required ? "*" : "") +
                        " " +
                        _vm._s(_vm.fieldName)
                    ),
                  ]
                }),
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.type === "checkbox"
          ? _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.model.$model,
                  expression: "model.$model",
                },
              ],
              staticClass: "form-control",
              attrs: {
                name: _vm.fieldName,
                placeholder: _vm.placeholder,
                type: "checkbox",
              },
              domProps: {
                checked: Array.isArray(_vm.model.$model)
                  ? _vm._i(_vm.model.$model, null) > -1
                  : _vm.model.$model,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.model.$model,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 &&
                        _vm.$set(_vm.model, "$model", $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        _vm.$set(
                          _vm.model,
                          "$model",
                          $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                        )
                    }
                  } else {
                    _vm.$set(_vm.model, "$model", $$c)
                  }
                },
              },
            })
          : _vm.type === "radio"
          ? _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.model.$model,
                  expression: "model.$model",
                },
              ],
              staticClass: "form-control",
              attrs: {
                name: _vm.fieldName,
                placeholder: _vm.placeholder,
                type: "radio",
              },
              domProps: { checked: _vm._q(_vm.model.$model, null) },
              on: {
                change: function ($event) {
                  return _vm.$set(_vm.model, "$model", null)
                },
              },
            })
          : _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.model.$model,
                  expression: "model.$model",
                },
              ],
              staticClass: "form-control",
              attrs: {
                name: _vm.fieldName,
                placeholder: _vm.placeholder,
                type: _vm.type,
              },
              domProps: { value: _vm.model.$model },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.model, "$model", $event.target.value)
                },
              },
            }),
        _vm._v(" "),
        _vm.showDescription
          ? _c("div", { staticClass: "description-block" }, [
              _c("i", [_vm._v(_vm._s(_vm.descriptionText))]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "help-block pull-right" }, [
          _vm.model.$error && _vm.model.required === false
            ? _c("span", [_vm._v(_vm._s(_vm.fieldName) + " is required")])
            : _vm._e(),
          _vm._v(" "),
          _vm.model.$error && _vm.model.email === false
            ? _c("span", [
                _vm._v(_vm._s(_vm.fieldName) + " is not a valid email"),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.model.$error && _vm.model.sameAsPassword === false
            ? _c("span", [
                _vm._v(_vm._s(_vm.fieldName) + " must be the same as password"),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.model.$error && _vm.model.uniqueEmail === false
            ? _c("span", [_vm._v("The email is already in use")])
            : _vm._e(),
          _vm._v(" "),
          _vm.model.$pending && _vm.model.uniqueEmail === false
            ? _c("span", [_vm._v("Checking that the email is not in use...")])
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }